import { createSlice } from "@reduxjs/toolkit"
import { IPatientReportResponse } from "@/modules/Patient/Overview/components/patientReportTables/patient-report.types"
import { fetchPatientReport } from "./patientReportThunkApi"

interface IPatientReportState {
  patientReport: IPatientReportResponse | null
  loading: "idle" | "pending" | "succeeded" | "failed"
}

const initialState: IPatientReportState = {
  patientReport: null,
  loading: "idle",
}

export const patientReportSlice = createSlice({
  name: "patientReport",
  initialState,
  reducers: {
    resetPatientReport(state) {
      state.patientReport = null
      state.loading = "idle"
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPatientReport.pending, (state) => {
      state.loading = "pending"
    })
    builder.addCase(fetchPatientReport.fulfilled, (state, action) => {
      state.patientReport = action.payload
      state.loading = "succeeded"
    })
    builder.addCase(fetchPatientReport.rejected, (state) => {
      state.patientReport = null
      state.loading = "failed"
    })
  },
})

export const { resetPatientReport } = patientReportSlice.actions
